import React from 'react';
import bemHelper from 'react-bem-helper';

import './styles.scss';

const bem = bemHelper({ prefix: 'toga-', name: 'storefront-section-text' });

class SectionTextModule extends React.Component {

  render() {
    const { title, summary, body, className } = this.props;

    return (
      <div {...bem(null, { center: true }, `text-group ${className}`)}>
        {title && <h2 {...bem('title')}>{title}</h2>}
        <div {...bem('body')}>
          {summary && <p {...bem('body--summary')}>
            {summary}
          </p>}
          {
             body && body.split(/(?:\r\n|\r|\n)/g).map((line, index) => {
               return <p {...bem('body-paragraph')} key={index}>{line}</p>;
             })
          }
        </div>
      </div>
    );
  }

}

export default SectionTextModule;



// WEBPACK FOOTER //
// ./src/components/storefront/components/SectionTextModule/SectionTextModule.js